import axios from "axios";
import {   getBaseURLforBackEnd  , getConfigAxios , customFormatDate, customFormatTime } from '@/utils.js'
import master_data from "./master_data";

export default {
    namespaced: true,
    state: {
        // listoflabopdtarget : [] ,
        listoflabopdtarget_v2 : [] ,
        datGrpUniqs : [],
        datWantToSee : []
    },

    getters: {
        listOfLabOPDTarget_ModifiedForDisplay (state) {
            return     state.listoflabopdtarget_v2.map( dat=>{
                // console.log(dat.tests)
                    return {
                        "idopd": dat.idopd,
                        "idlab": dat.idlab,
                        "opdname": dat.opdname,
                        "type": dat.type,
                        "owner_name": dat.owner_name,
                        "status": dat.status,
                        "gender": dat.gender,
                        "age": dat.age,
                        "kind": dat.kind,
                        "automate": dat.automate,
                        "datereq" :   customFormatDate(dat.datereq) ,
                        "timereq" :   customFormatTime(dat.timereq) ,
                        "reqby": dat.reqby,
                        "dateaccept":   customFormatDate(dat.dateaccept)  ,
                        "timeaccept":   customFormatTime(dat.timeaccept) ,
                        "acceptby": dat.acceptby,
                        "datecancle":   customFormatDate(dat.datecancle),
                        "timecancle":   customFormatTime(dat.timecancle),
                        "cancleby": dat.cancleby,
                        "datereject":   customFormatDate(dat.datereject) ,
                        "timereject":   customFormatTime(dat.timereject),
                        "rejectby": dat.rejectby,
                        "dateresult":   customFormatDate(dat.dateresult) ,
                        "timeresult":   customFormatTime(dat.timeresult),
                        "resultby": dat.resultby,
                        "tests" : dat.tests,
                        "tests_v3": dat.tests_v3,
                        "version": dat.version
                    }
                })


        }
    },

    mutations: {
        // setListOfLab_OPDTarget (state, listoflabopdtarget) {
        //     state.listoflabopdtarget = listoflabopdtarget
        // },

        setListOfLab_OPDTarget_v2 (state, listoflabopdtarget_v2) {
            state.listoflabopdtarget_v2 = listoflabopdtarget_v2
        },


        setDatGrpUniqs (state, datGrpUniqs) {
            state.datGrpUniqs = datGrpUniqs
        },

        setDatWantToSee (state, datWantToSee) {
            state.datWantToSee = datWantToSee
        },

        setEmptyListOfLab_OPDTarget (state, listoflabopdtarget) {
            state.listoflabopdtarget = listoflabopdtarget
        },
    },

    actions: {
        produceDatWantToSee({commit},datWantToSee){
            commit('setDatWantToSee', datWantToSee)
        },

        produceDatGrpUniqs({commit},datGrpUniqs){
            commit('setDatGrpUniqs', datGrpUniqs)
        },



        // takeEmptyListOfLab_OPDTarget({commit}){
        //     commit('setListOfLab_OPDTarget', [])
        // },


        takeEmptyListOfLab_OPDTarget_v2({commit}){
            commit('setListOfLab_OPDTarget_v2', [])
        },


 



        fetchListOfLab_OPDTargetV2({commit},idopd) {
            const opdwanto =      {
                "idopd": idopd
            }


            return new Promise((resolve) => {
                axios.defaults.headers.common['Authorization'] =  `Bearer ${master_data.state.access_token}`
                // axios.post(`${getBaseURLforBackEnd()}/api/lablist_spec_opdno`, opdwanto ,getConfigAxios())
                // axios.post(`${getBaseURLforBackEnd()}/api/lablist_spec_opdno_v2`, opdwanto ,getConfigAxios())
                axios.post(`${getBaseURLforBackEnd()}/api/lablist_spec_opdno_v3`,opdwanto,getConfigAxios())
                    .then((res)=>{
                        // console.log(JSON.stringify(res.data));
                        commit('setListOfLab_OPDTarget_v2', res.data)
                        const tmpDatGrpUniqs = []
                        const tmpDatWantToSee = []
                        res.data.map(dat=>{

                             if (tmpDatGrpUniqs.indexOf(dat.kind) === -1){
                                 tmpDatGrpUniqs.push(dat.kind)
                                 tmpDatWantToSee.push(dat.kind)
                             }
                        })

                        commit('setDatGrpUniqs', tmpDatGrpUniqs)
                        commit('setDatWantToSee', tmpDatWantToSee)

                        resolve(res)
                    })
                    .catch((err)=>{
                        resolve(err)
                    })

            })
        }


    }
}